import { NAVIGATION_KEYS_CODES } from '../constants/keyboard';
export function onKeyDown(e) {
  if (!e.key.match(/\d/) && !NAVIGATION_KEYS_CODES.includes(e.key)) {
    e.preventDefault();
  }
}